import { render, staticRenderFns } from "./referralTab.vue?vue&type=template&id=2bb65590&scoped=true"
import script from "./referralTab.vue?vue&type=script&lang=js"
export * from "./referralTab.vue?vue&type=script&lang=js"
import style0 from "./referralTab.vue?vue&type=style&index=0&id=2bb65590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb65590",
  null
  
)

export default component.exports